import { render } from "./GameCardsStack.vue?vue&type=template&id=6e45f5ea"
import script from "./GameCardsStack.vue?vue&type=script&lang=js"
export * from "./GameCardsStack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zekarim/Documents/HEIG/roesti-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__